import React from 'react'

import { ScoutConfirmation } from '../components'

const ScoutConfirmationPage: React.FC = () => {
  return <ScoutConfirmation />
}

export default ScoutConfirmationPage
